<template>
  <main>
    <container-small>
      <background-wrapper :color="'#42337E'" content-padding="7px 0">
        <div class="banner">{{ $t(`${$route.name}.banner`) }}</div>
      </background-wrapper>
      <background-wrapper :src="routeNameKebab + '/fullscreen-image_hero'" ext="png">
        <div class="hero">
          <text-container size="sm">
            <img class="hero__icon mb-3" :src="require(`@/assets/${routeNameKebab}/hero.svg`)"/>
            <h1 v-html="$t(`${$route.name}.title`)"/>
            <p class="h-sub" v-html="$t(`${$route.name}.subtitle`)"/>
            <b-btn variant="primary" to="hellohr">{{$t('get-the-details')}}</b-btn>
          </text-container>
        </div>
      </background-wrapper>
      <background-wrapper :src="routeNameKebab + '/fullscreen-image_consulting-services'" ext="png">
        <div class="consulting-services">
          <text-container size="sm">
            <h2 class="h1" v-html="$t(`${$route.name}.consulting-services.title`)"/>
            <p class="h-sub" v-html="$t(`${$route.name}.consulting-services.subtitle`)"/>
            <b-btn variant="primary" v-scroll-to="{ el: '#' + $t(`${$route.name}.contact-consulting.id`), offset: -70 }">
              {{$t('lets-get-started')}}
            </b-btn>
            <p class="mt-3" v-html="$t(`${$route.name}.consulting-services.hint`)"/>
          </text-container>
        </div>
      </background-wrapper>
    </container-small>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_our-services'" ext="png">
      <div class="our-services">
        <b-nav class="mb-4" align="center">
          <li class="m-1 ml-2 mr-2 ml-md-1 mr-md-1" v-for="n in 5" :key="n">
            <b-btn variant="light" size="sm" pill class="px-2 border-primary font-weight-normal"
              v-scroll-to="{ el: '#' + $t(`${$route.name}.our-services.btn-list.${n}.el`), offset: -70 }"
            >
              {{$t(`${$route.name}.our-services.btn-list.${n}.title`)}}
            </b-btn>
          </li>
        </b-nav>
        <text-container size="lg" align-center justify-center>
          <h2 class="h1" v-html="$t(`${$route.name}.our-services.title`)"/>
          <p class="h-sub mb-6" v-html="$t(`${$route.name}.our-services.subtitle`)"/>
        </text-container>
        <b-row class="justify-content-center">
          <b-col class="mt-3" cols="12" sm="6" md="6" lg="4" v-for="n in 9" :key="n">
            <b-card class="h-100">
              <img class="mb-2" :src="require(`@/assets/${routeNameKebab}/our-services_${n}.svg`)"/>
              <h3 class="h2 mb-2">{{$t(`${$route.name}.our-services.items.${n}.title`)}}</h3>
              <p v-html="$t(`${$route.name}.our-services.items.${n}.text`)" />
              <template #footer>
                <b-link v-scroll-to="{ el: '#' + $t(`${$route.name}.contact-consulting.id`), offset: -70 }">{{$t('get-started')}}</b-link>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <background-wrapper color="#F5FBFF">
      <div class="projects-your-way" :id="$t(`${$route.name}.projects-your-way.id`)">
        <h2 class="h1 text-center mb-4" v-html="$t(`${$route.name}.projects-your-way.title`)"/>
        <b-row align-h="center">
          <b-col class="mt-3" cols="12" md="6" lg="4" v-for="n in 3" :key="n">
            <b-card class="shadow" align="center">
              <img class="projects-your-way__image" :src="require(`@/assets/${routeNameKebab}/projects-your-way_${n}.svg`)"/>
              <h3 class="h2 my-4">{{$t(`${$route.name}.projects-your-way.items.${n}.title`)}}</h3>
              <ul class="text-left">
                <li class="mb-2" v-for="m in 2" :key="m" v-html="$t(`${$route.name}.projects-your-way.items.${n}.list.${m}`)" />
              </ul>
              <template #footer>
                <b-btn variant="primary" v-scroll-to="{ el: '#' + $t(`${$route.name}.contact-consulting.id`), offset: -70 }">{{$t('get-started')}}</b-btn>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <text-container class="agile-projects" size="lg" align-center justify-center>
      <h2 class="text-center" v-html="$t(`${$route.name}.agile-projects.title`)"/>
      <p class="h-sub" v-html="$t(`${$route.name}.agile-projects.subtitle`)"/>
      <img class="agile-projects__image" :src="require(`@/assets/${routeNameKebab}/agile-projects.png`)"/>
    </text-container>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_meet-the-team'" ext="png">
      <div class="meet-the-team" :id="$t(`${$route.name}.meet-the-team.id`)">
        <h2 class="h1 text-center mb-4" v-html="$t(`${$route.name}.meet-the-team.title`)"/>
        <text-container class="mb-5" size="lg" align-center justify-center>
          <p class="h-sub" v-html="$t(`${$route.name}.meet-the-team.subtitle`)" />
        </text-container>
        <b-row align-h="center">
          <b-col class="mt-3" cols="6" sm="4" v-for="n in 5" :key="n" align="center">
            <img class="meet-the-team__image" :src="require(`@/assets/${routeNameKebab}/meet-the-team_${n}.png`)"/>
            <div class="teammate-info">
              <h3 class="h4 mb-1">{{$t(`${$route.name}.meet-the-team.items.${n}.title`)}}</h3>
              <p class="" v-html="$t(`${$route.name}.meet-the-team.items.${n}.subtitle`)" />
            </div>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <div class="our-skill-set" :id="$t(`${$route.name}.our-skill-set.id`)">
      <h2 class="h1 text-center mb-4" v-html="$t(`${$route.name}.our-skill-set.title`)"/>
      <b-row align-h="center">
        <b-col class="mt-3" cols="12" md="6">
          <b-card class="our-skill-set__item our-skill-set--blue">
            <h3 class="h2 text-center" v-html="$t(`${$route.name}.our-skill-set.items.1.title`)"/>
            <ul class="mb-0">
              <li v-for="n in 11" :key="n">
                {{$t(`${$route.name}.our-skill-set.items.1.list.${n}`)}}
              </li>
            </ul>
          </b-card>
        </b-col>
        <b-col class="mt-3" cols="12" md="6">
          <b-card class="our-skill-set__item our-skill-set--cyan">
            <h3 class="h2 text-center" v-html="$t(`${$route.name}.our-skill-set.items.2.title`)"/>
            <ul class="mb-0">
              <li v-for="n in 10" :key="n">
                {{$t(`${$route.name}.our-skill-set.items.2.list.${n}`)}}
              </li>
            </ul>
          </b-card>
        </b-col>
        <b-col class="mt-3" cols="12" md="8">
          <b-card class="our-skill-set__item our-skill-set--orange">
            <h3 class="h2 text-center" v-html="$t(`${$route.name}.our-skill-set.items.3.title`)"/>
            <b-row>
              <b-col>
                <ul class="mb-0">
                  <li v-for="n in 5" :key="n">
                    {{$t(`${$route.name}.our-skill-set.items.3.list.${n}`)}}
                  </li>
                </ul>
              </b-col>
              <b-col>
                <ul class="mb-0">
                  <li v-for="n in 5" :key="n + 5">
                    {{$t(`${$route.name}.our-skill-set.items.3.list.${n + 5}`)}}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <container-small>
      <div class="client-testimonials" :id="$t(`${$route.name}.client-testimonials.id`)">
        <h2 class="h1 text-center mb-4" v-html="$t(`${$route.name}.client-testimonials.title`)"/>
        <div class="client-testimonials__wrapper">
          <VueSlickCarousel :arrows="true" v-bind="settings">
            <div v-for="n in 4" :key="n">
              <div class="text-center">
                <p class="h-sub mb-3">{{$t(`${$route.name}.client-testimonials.items.${n}.text`)}}</p>
                <small>{{$t(`${$route.name}.client-testimonials.items.${n}.author`)}}</small>
              </div>
            </div>
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-left.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-right.svg">
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="slider-wrapper mt-5">
          <VueSlickCarousel :arrows="true" v-bind="settings_2">
            <div v-for="n in 12" :key="n">
              <div class="great-companies__image">
                <img :src="require(`@/assets/${routeNameKebab}/slider/slide_${n}.png`)">
              </div>
            </div>
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-left.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-right.svg">
              </div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
      <div class="working-with-us">
        <h2 class="h1 text-center mb-5" v-html="$t(`${$route.name}.working-with-us.title`)"/>
        <div class="working-with-us__cards">
          <b-card>
            <img :src="require(`@/assets/${routeNameKebab}/working-with-us_1.svg`)">
            <div class="working-with-us__info">
              <h3 class="h2 mb-2" v-html="$t(`${$route.name}.working-with-us.items.1.title`)"/>
              <ul class="text-left ml-n2">
                <li class="mb-2" v-for="n in 2" :key="n">
                  {{$t(`${$route.name}.working-with-us.items.1.list.${n}`)}}
                </li>
              </ul>
            </div>
          </b-card>
          <b-card>
            <img :src="require(`@/assets/${routeNameKebab}/working-with-us_2.svg`)">
            <div class="working-with-us__info">
              <h3 class="h2 mb-2" v-html="$t(`${$route.name}.working-with-us.items.2.title`)"/>
              <ul class="text-left ml-n2">
                <li class="mb-2" v-for="n in 4" :key="n">
                  {{$t(`${$route.name}.working-with-us.items.2.list.${n}`)}}
                </li>
              </ul>
            </div>
          </b-card>
          <h3 class="h2 mt-4 mb-0 text-center" v-html="$t(`${$route.name}.working-with-us.second-title`)"/>
        </div>
      </div>
      <background-wrapper color="#F5FBFF">
        <div class="not-a-member-yet">
          <h2 class="h1 text-center mb-2" v-html="$t(`${$route.name}.not-a-member-yet.title`)"/>
          <p class="h-sub text-center mb-4" v-html="$t(`${$route.name}.not-a-member-yet.subtitle`)"/>
          <b-row align-v="center">
            <b-col cols="12" md="6">
              <img class="not-a-member-yet__image" :src="require(`@/assets/${routeNameKebab}/what-makes-us-different.png`)"/>
            </b-col>
            <b-col cols="10" offset="1" md="6" offset-md="0">
              <h3 class="h2 my-3">{{$t(`${$route.name}.what-makes-us-different.title`)}}</h3>
              <ul class="text-left ml-n2">
                <li class="mb-2" v-for="n in 4" :key="n">
                  {{$t(`${$route.name}.what-makes-us-different.list.${n}`)}}
                </li>
              </ul>
              <b-btn class="mt-2" variant="primary" to="request-a-demo">
                {{$t(`request-demo`)}}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </background-wrapper>
      <background-wrapper :src="routeNameKebab + '/fullscreen-image_contact-consulting'" ext="png">
        <div class="contact-consulting" :id="$t(`${$route.name}.contact-consulting.id`)">
          <h2 class="h1 text-center mb-6" v-html="$t(`${$route.name}.contact-consulting.title`)"/>
          <b-row align-v="center">
            <b-col cols="12" lg="6">
              <h3 class="h2 mb-2">{{$t(`${$route.name}.contact-consulting.second-title`)}}</h3>
              <p class="h-sub mb-0" v-html="$t(`${$route.name}.contact-consulting.text`)"/>
              <div class="ml-n5 d-none d-lg-block">
                <img class="contact-consulting__image" :src="require(`@/assets/${routeNameKebab}/contact-consulting.png`)"/>
              </div>
            </b-col>
            <b-col cols="12" md="12" lg="6">
              <div id="hubspotForm" v-once class="card pt-4 px-4 pb-3"/>
            </b-col>
          </b-row>
        </div>
      </background-wrapper>
    </container-small>
  </main>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'Consulting',
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  components: { VueSlickCarousel },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '1890515',
          formId: 'de1de1e8-00a8-4dca-963e-e217eb8c1c53',
          sfdcCampaignId: '7011B0000028yHDQAY',
          target: '#hubspotForm'
        })
      }
    })
  },
  data () {
    return {
      settings: {
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000
      },
      settings_2: {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.hero
  padding: 170px 0 200px
  +media-breakpoint-down(md)
    padding: 100px 0 100px
  +media-breakpoint-down(sm)
    padding: 80px 0 440px

.consulting-services
  padding: 100px 0
  +media-breakpoint-down(sm)
    padding: 125px 0
  +media-breakpoint-down(xs)
    padding: 80px 0

  .text-container
    +media-breakpoint-down(sm)
      text-align: left!important
      justify-items: start!important
      max-width: 400px

      p.h-sub
        font-size: 16px
        +media-breakpoint-down(md)
          width: 88%

    +media-breakpoint-down(xs)
      max-width: 65vw

.our-services
  padding: 120px 0 150px

  +media-breakpoint-down(sm)
    p.h-sub
      margin-bottom: 220px!important

  +media-breakpoint-down(xs)
    p.h-sub
      margin-bottom: 180px!important

  .card-body
    padding-bottom: 0

  .card-footer
    padding-top: 0
    background-color: #fff
    border: none

.projects-your-way
  padding: 110px 0 140px

  &__image
    margin-top: -140px
    margin-bottom: -40px

  .row > [class*='col-']
    display: flex

  .card
    margin-top: 70px

  .card-footer
    padding-top: 0
    padding-bottom: 40px
    background-color: #fff
    border: none

.agile-projects
  margin: 150px auto

  &__image
    max-width: 100%
    width: 100%

.meet-the-team
  padding-bottom: 500px
  +media-breakpoint-down(sm)
    padding-bottom: 250px

  &__image
    max-width: 100%

  .teammate-info
    margin-top: 20px
    max-width: 320px
    text-align: center

    p
      color: #383B41

.our-skill-set
  margin: 120px auto 150px

  &__item
    height: 100%
    border: solid 5px #000
    border-radius: 8px

    li
      margin-top: 8px

  &--blue
    border-color: #0072E0
  &--cyan
    border-color: #0FC3A5
  &--orange
    border-color: #FFE451

.client-testimonials
  margin-bottom: 150px
  h2
    +media-breakpoint-down(xs)
      font-size: 2.2rem
  p
    +media-breakpoint-down(xs)
      font-size: 18px
  img
    +media-breakpoint-down(xs)
      width: 100%;
  &__wrapper
    padding: 0 40px

.custom-arrow
  color: $dark
  font-size: 14px
  height: 29px
  &:before
    content: none

.slider-wrapper
  padding: 0 40px

.great-companies
  &__image
    display: flex
    align-items: center
    justify-content: center
    padding: 0 20px
    height: 70px
    width: 100%

    img
      max-height: 100%

.working-with-us
  margin-bottom: 120px

  &__cards
    display: grid
    grid-template-columns: minmax(0, 750px)
    grid-gap: $spacer
    justify-content: center
    +media-breakpoint-down(md)
      grid-template-columns: minmax(0, 700px)

  .card .card-body
    display: grid
    grid-template-columns: 194px 1fr
    grid-gap: 40px
    align-items: start
    justify-items: center
    +media-breakpoint-down(md)
      grid-template-columns: 154px 1fr
      grid-gap: 30px
    +media-breakpoint-down(sm)
      grid-template-columns: 124px 1fr
      grid-gap: 20px
    +media-breakpoint-down(xs)
      grid-template-columns: minmax(0, 1fr)
      justify-items: start

    img
      max-width: 114px
      +media-breakpoint-down(sm)
        max-width: 94px

.not-a-member-yet
  padding: 100px 0 120px

  &__image
    max-width: 100%
    width: 100%

.contact-consulting
  padding: 120px 0 100px

  &__image
    max-width: 100%
    width: 100%
.testimonial-image
  +media-breakpoint-down(lg)
    width: 80%
</style>



// WEBPACK FOOTER //
// src/components/consulting/Consulting.vue